import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import PhotoSwiper from 'dibs-interiors-photos/exports/PhotoSwiper';
import PhotoContainer from 'dibs-interiors-photos/exports/PhotoContainer';
import { filterNulls } from 'dibs-ts-utils/exports/filterNulls';
import { usePhotoSwiperState } from './usePhotoSwiperState';

import { type PhotosSearchBrowsePhotoPreviewPhotoSwiper_photos$key } from './__generated__/PhotosSearchBrowsePhotoPreviewPhotoSwiper_photos.graphql';

type Props = {
    photos: PhotosSearchBrowsePhotoPreviewPhotoSwiper_photos$key | null | undefined;
    currentPhotoIndex: number;
    modalPhotoIndex: number;
    page: number;
    itemsOnPage: number;
    totalResults: number;
    changePhotoIndex: ({ direction }: { direction: 'prev' | 'next' }) => void;
};

const PhotosSearchBrowsePhotoPreviewPhotoSwiper: FC<Props> = ({
    photos: photosRef,
    modalPhotoIndex,
    currentPhotoIndex,
    page,
    itemsOnPage,
    totalResults,
    changePhotoIndex,
}) => {
    const photos = useFragment(
        graphql`
            fragment PhotosSearchBrowsePhotoPreviewPhotoSwiper_photos on PhotosSearchBrowseQueryConnection {
                edges {
                    node {
                        id
                        serviceId
                        path
                        url
                        name
                        width
                        height
                        styles {
                            name
                        }
                        room {
                            name
                        }
                    }
                }
            }
        `,
        photosRef
    );

    const { swiperKey, startingPage, onPageChange } = usePhotoSwiperState({
        page,
        modalPhotoIndex,
        itemsOnPage,
        totalResults,
        currentPhotoIndex,
        changePhotoIndex,
    });

    return (
        <PhotoSwiper key={swiperKey} startingPage={startingPage} onPageChange={onPageChange}>
            <span />
            {(photos?.edges || []).filter(filterNulls).map((photoEdge, photoEdgeIndex) => {
                const photoNode = photoEdge.node;
                if (photoNode) {
                    const photoId = photoNode.serviceId || '';
                    return (
                        <PhotoContainer
                            key={photoId || photoEdgeIndex}
                            shouldShowImage={photoEdgeIndex + 1 === startingPage}
                            photo={photoNode}
                            index={photoEdgeIndex}
                        />
                    );
                }
                return null;
            })}
            <span />
        </PhotoSwiper>
    );
};

export default PhotosSearchBrowsePhotoPreviewPhotoSwiper;
